import { createFileRoute } from '@tanstack/react-router';

// relative imports
import Loader from '../../../../../../components/shared/custom-components/Loader';
import WalletSummary from '../../../../../../components/source-management/wallets/wallet-page/WalletSummary';

export const Route = createFileRoute(
  '/_authenticated/(sources)/wallets/$walletId/_wallet/summary',
)({
  pendingComponent: () => (
    <Loader marginTop={3} fillSpace LoaderContainerClasses={{}} />
  ),
  component: WalletSummary,
});
